module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_13.bf1c3ad2.pdf";